import { faEdit } from "@fortawesome/free-solid-svg-icons"
import { faUser } from "@fortawesome/free-solid-svg-icons/faUser"
import StyledInputField from "../../../../../components/parts/styled-field/styled-input-field"
import { IStyledFieldProps } from "../../../../../components/parts/styled-field/styled-input-field"
import StyledTextareaField from "../../../../../components/parts/styled-field/styled-textarea-field"
import { Channel } from "../../../../../rpcs/dist/ChannelRPC"
import StyledUrlField from "./components/styled-url-field"
import { IStyledUrlFieldProps } from "./components/styled-url-field"

export const FormId = "ChannelSettingForm"

export type IFormField = Pick<Channel, "name" | "screenName"> & {
  description: string
}

export const formData: Array<
  IStyledFieldProps<keyof IFormField> | IStyledUrlFieldProps
> = [
  {
    name: "screenName",
    title: "チャンネル名",
    icon: faUser,
    type: "text",
    placeholder: "チャンネル名",
    component: StyledInputField,
  },
  {
    name: "description",
    title: "チャンネル説明",
    icon: faEdit,
    type: "text",
    placeholder: "チャンネル説明",
    component: StyledTextareaField,
  },
  {
    name: "name",
    title: "チャンネルURL",
    placeholder: "チャンネルURL",
    component: StyledUrlField,
  },
]
